import { ActionType } from './index';
export const SET_SITE_ATTRIBUTES = 'SET_SITE_ATTRIBUTES';
export interface SiteAttributesPayloadProps {
  cf_country: string;
  isEuUser: boolean;
  captcha: {
    captcha_key: string;
    source: string;
  };
  isJoinCaptchaEnabled: boolean;
  isLoginCaptchaEnabled: boolean;
}

export interface SiteAttributeAction extends ActionType {
  payload?: SiteAttributesPayloadProps;
}
